export type UseMobileConfigProps = {
  enabled: boolean;
}

export function useMobileConfig({ enabled }: UseMobileConfigProps) {
  if (!enabled) {
    return <></>
  }

  return (
    <>
      <meta key='apple-mobile-web-app-capable' name='apple-mobile-web-app-capable' content='yes' />
      <meta key='apple-mobile-web-app-status-bar-style' name='apple-mobile-web-app-status-bar-style' content='default' />
      <meta key='mobile-web-app-capable' name='mobile-web-app-capable' content='yes' />
    </>
  )
}